import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

//@ts-ignore
import ActionCreditsRequiredText from '@/components/BlockEditor/IntegrationEditor/ActionCreditsRequiredText.vue';
import AppActionService from '@/utils/AppActionService';


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionCreditsRequiredMenu',
  props: {
	action: { type: Object, required: true },
},
  setup(__props) {

const props = __props



const isCreditsBased = computed(() => AppActionService.isActionCreditBased(props.action));

return { __sfc: true,props, isCreditsBased, ActionCreditsRequiredText }
}

})